@if ((isCashoutAvailable && !isQuickbet) || promoLabels.length || isBogEnabled) {
    <div class="promo-labels {{ mode }}">
        <!-- Cashout label -->
        @if (isCashoutAvailable && !isQuickbet) {
            <div class="cashout-label-wrapper" [ngClass]="{ 'betslip-single-receipt-co-label': betslipSingleReceiptPromo }">
                <svg class="cashout-icon" width="11px" height="11px">
                    <use xlink:href="#cashout-icon"></use>
                </svg>
                <span class="cashout-label" [i18n]="'app.cashout'" data-crlat="labelCashout"></span>
            </div>
        }

        <!-- Promo labels -->
        @if (isPromoSignpostingEnabled) {
            @for (label of promoLabels; track $index) {
                <span class="{{ label.id.substring(1) }} promo-label {{ label?.eventFlag?.toLowerCase() }}" [ngClass]="{ 'quacca-sp': isQuacca }">
                    <svg width="12px" height="12px" class="promo-icon">
                        <use [attr.xlink:href]="label.id" data-crlat="promo.icon"></use>
                    </svg>
                    @if (!isFromMyBets) {
                        <span [i18n]="'bma.' + label.name" data-crlat="promo.label" class="promo-lable"></span>
                    }
                </span>
            }
        }

        @if (isBogEnabled) {
            <bog-label [bogLabelStyle]="true"></bog-label>
        }
    </div>
}
